(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name targetHours.controller:TargetHoursCtrl
   *
   * @description
   *
   */
  angular
    .module('targetHours')
    .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
    .controller('TargetHoursCtrl', TargetHoursCtrl);

  function TargetHoursCtrl(CommonMasterData,AutoRosterScheduleService,applicationConstants,TargetHoursService,MessageService,EventManagerService,$sce,RemoteService, CommonLogicService, $timeout) {
    var vm = this;
    vm.limitIndex = 30;
    vm.ctrlName = 'TargetHoursCtrl';
    vm.isBusyInRendering = false;
    vm.model = {
            searchPanelToggle: true,
            initialSearchDone: false,
            editorMode: applicationConstants.EDITOR_STATUS.ADD,
            searchCriteria: {
                crewBase: null,
                flexiContract: null,
                modelNumber: null,
                crewType: null,
                cycle :null,
                group:null
            },
            masterList: {
                crewTypes: [],
                cycleList: [],
                fleetTypes: [],
                acModels: [],
                crewBases: [] ,
                flexiContractList:[],
                crewGroups:[],
                allRowSelected:false
            },
            gridDataList: [],
            selectedRow: null,
            requestPriorities:null,
            tHrsToBesdest:'00:00',
            totalTargetHrs : '00:00',
            totalAcctFlyingHrs : '00:00',
            isElasticLoadingVisible: false,
            isFullScreen : false,
            mode :null,
            reportUrl:null,
            reportServerBaseUrl:null,
            hideAc:false,
            calTargetHoursList:[],
            allRowSelected:false,
            flexiHoursPopulated:false
        };

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone = false;

    };

    vm.search = function () {
        vm.model.gridDataList = [];
        vm.model.initialSearchDone=true;
        console.log(vm.model.searchCriteria);
        searchTargetHours();
        vm.model.mode = TargetHoursService.mode.searchMode;
        vm.model.flexiHoursPopulated = false;
      };

    vm.populateFlexiFixedHrs = function (){
      if (vm.model.mode === TargetHoursService.mode.calMode) {
        vm.model.flexiHoursPopulated = true;
        var list = vm.model.gridDataList;
        console.log(list);
        for(var i = 0; i < list.length; i++){
          var a = 0;
          if(list[i].isCrewOnFlexiContract){
            var isFixed = list[i].isCrewOnFlexiContract;
            list[i].targetNightHrs[a].isFixed = isFixed;
            list[i].targetHrs[a].isFixed = isFixed;
            list[i].targetNightDepartures[a].isFixed = isFixed;
            list[i].targetHrs[a].hours = list[i].fixedFlexiHrs;
            for(a = 1; a < list[i].targetHrs.length; a++){
              list[i].targetHrs[a].hours = 0;
            }
          }
        }
        vm.model.gridDataList = list;

        list = vm.targetHoursDataList;

        for(var i = 0; i < list.length; i++){
          var a = 0;
          if(list[i].isCrewOnFlexiContract){
            var isFixed = list[i].isCrewOnFlexiContract;
            list[i].targetNightHrs[a].isFixed = isFixed;
            list[i].targetHrs[a].isFixed = isFixed;
            list[i].targetNightDepartures[a].isFixed = isFixed;
            list[i].targetHrs[a].hours = list[i].fixedFlexiHrs;
            for(a = 1; a < list[i].targetHrs.length; a++){
              list[i].targetHrs[a].hours = 0;
            }
          }
        }
      } else {
        MessageService.error('Please calculate target hours Before!');
      }

    }

    vm.calculate = function (){
    	var girdData = vm.targetHoursDataList;
    	TargetHoursService.setSearchCriteria(vm.model.searchCriteria,girdData);
    	TargetHoursService.getTargetHours(
                function (list) {
                	 vm.model.gridDataList = [];
                	 vm.limitIndex = 30;
	              	 vm.targetHoursDataList = TargetHoursService.getFormattedData(list.targetHours);
	              	 vm.model.calTargetHoursList = vm.targetHoursDataList;
	              	 vm.model.totalTargetHrs = '00:00';
	              	 vm.model.totalAcctFlyingHrs = '00:00';
                  if(list.totalTargetHrs != 0){
                    vm.model.totalTargetHrs = list.totalTargetHrs;
                   }
                   if(list.totalAcctFlyingHrs != 0){
	              	   vm.model.totalAcctFlyingHrs = list.totalAcctFlyingHrs;
                   }
		           	 for(var i=0, index=0; i < (vm.targetHoursDataList.length < vm.limitIndex ? vm.targetHoursDataList.length : vm.limitIndex); i++){
		           		 $timeout(function(){
		           			 vm.model.gridDataList.push(vm.targetHoursDataList[index]);
		           			 index++;
		           		 });
		           	  }
	            	 vm.model.searchPanelToggle = false;
	            	 MessageService.success('calculated Successfully');
	            	 vm.model.mode = TargetHoursService.mode.calMode;
                 vm.model.flexiHoursPopulated = false;
                },
                function (error) {
                    MessageService.error(error);

                }
            );
    };

	    function getNextSetOfRecords() {
	    	if(!vm.isBusyInRendering){
	    		vm.limitIndex = (vm.model.gridDataList.length + vm.limitIndex) < vm.targetHoursDataList.length ? vm.limitIndex :vm.targetHoursDataList.length-vm.model.gridDataList.length;
	        	for(var i = 0, asyncIndex = 0, index = vm.model.gridDataList.length ; i < vm.limitIndex; i++){
	    			$timeout(function(){
	    				vm.isBusyInRendering = true;
	    				vm.model.gridDataList.push(vm.targetHoursDataList[index]);
	    				index++;
	    				asyncIndex++;
	    				if(asyncIndex == vm.limitIndex){
	    					vm.isBusyInRendering = false;
	    				}
	    			});
	    		}
	    	}
	    }

      function searchTargetHours() {
    	vm.model.requestPriorities = vm.model.searchCriteria.cycle.crewGroupCode;
    	TargetHoursService.setSearchCriteria(vm.model.searchCriteria,null);
    	TargetHoursService.getTargetHours(
              function (list) {
            	 vm.targetHoursDataList = TargetHoursService.getFormattedData(list.targetHours);
            	 vm.model.totalTargetHrs = '00:00';
            	 vm.model.totalAcctFlyingHrs = '00:00';
            	 if(list.totalTargetHrs != 0){
                 vm.model.totalTargetHrs = list.totalTargetHrs;
               }
            	 if(list.totalAcctFlyingHrs != 0){
                 vm.model.totalAcctFlyingHrs = list.totalAcctFlyingHrs;
               }
            	 vm.model.gridDataList=[];
            	 vm.limitIndex = 30;
            	 for(var i=0, index=0; i < (vm.targetHoursDataList.length < vm.limitIndex ? vm.targetHoursDataList.length : vm.limitIndex); i++){
            		 $timeout(function(){
            			 vm.model.gridDataList.push(vm.targetHoursDataList[index]);
            			 index++;
            		 });
            	 }

              	 vm.model.searchPanelToggle = false;
              	 vm.model.tHrsToBesdest= list.tHrsToBesdest;

            	 if(vm.targetHoursDataList.length ===0){
            	   MessageService.error('No Records found');
               }

              },
              function (error) {
                  MessageService.error(error);

              }
          );
      }

      vm.onChanges = function(selectedRowData, flag){
    	  var hrsList = [];

    	  if(flag === 'selectAll'){
    		  selectAllRows();
    		  return;
    	  }

    	  if(flag === 'target'){
    		  hrsList = selectedRowData.targetHrs;
    	  }else if(flag === 'nights'){
    		  hrsList = selectedRowData.targetNightHrs;
    	  }else{
    		  hrsList = selectedRowData.targetNightDepartures;
    	  }
    	  var list = vm.model.gridDataList;
    	  for(var i = 0; i<list.length;i++){
    		  if(list[i].crewProfileId === selectedRowData.crewProfileId){
    			  for(var a = 0; a < hrsList.length;a++){
    				  list[i].targetNightHrs[a].isFixed = hrsList[a].isFixed;
    				  list[i].targetHrs[a].isFixed = hrsList[a].isFixed;
    				  list[i].targetNightDepartures[a].isFixed = hrsList[a].isFixed;
    			  }
    		  }
    	  }
    	  vm.model.gridDataList = list;
      };

      function selectAllRows(){
    	  vm.model.allRowSelected = !vm.model.allRowSelected;

    	  var list = vm.targetHoursDataList;
    	  angular.forEach(list, function (targetHourDto) {
    		  angular.forEach(targetHourDto.targetNightHrs, function (targetNightHrs) {
    			  targetNightHrs.isFixed = vm.model.allRowSelected;
    		  });

    		  angular.forEach(targetHourDto.targetHrs, function (targetHrs) {
    			  targetHrs.isFixed = vm.model.allRowSelected;
    		  });

    		  angular.forEach(targetHourDto.targetNightDepartures, function (targetNightDepartures) {
    			  targetNightDepartures.isFixed = vm.model.allRowSelected;
    		  });
          });

      }


    vm.saveTargetHours = function(){
    	TargetHoursService.setSaveData(vm.model.calTargetHoursList,vm.model.searchCriteria);
      if (vm.model.flexiHoursPopulated) {
        MessageService.error('Please recalculate target hours Before save!');
        return;
      }
    	if(vm.model.mode === TargetHoursService.mode.calMode){
    	TargetHoursService.saveTargetHours(
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully saved the record!');
                        vm.model.mode = TargetHoursService.mode.saveMode;
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
    	}else{
    		MessageService.error('Please calculate target hours Before save!');
    	}
    };

    vm.changeCriteria = function(items,flag){

    };

    vm.generateReport = function(){
    	if(vm.model.mode === TargetHoursService.mode.saveMode || vm.model.mode ===TargetHoursService.mode.searchMode){

        var url = CommonLogicService.getReportUrl('target_hours.rptdesign&__format=xls',getSearchParamMap());
        console.log(url);
        vm.model.reportUrl = $sce.trustAsResourceUrl(url);
    	window.open(vm.model.reportUrl);

    	}else{
    		MessageService.error('Before saved the records!');
    	}
    }

    function getSearchParamMap(){
    	var searchParamMap = {};
        searchParamMap["PC_CYCLE_ID"] = vm.model.searchCriteria.cycle.cycleId;;
        searchParamMap["PC_CREW_TYPE"] = vm.model.searchCriteria.crewType.crewTypeCode;
        searchParamMap["PC_AIRCRAFT_MODEL"]= vm.model.searchCriteria.modelNumber == null ? "" :vm.model.searchCriteria.modelNumber.modelNumber;
        searchParamMap["PC_CREW_BASE"]= vm.model.searchCriteria.crewBase ==null ? "" :vm.model.searchCriteria.crewBase.airPortCode;
        searchParamMap["TOT_FLY_TO_BE_DEST"]= vm.model.tHrsToBesdest;
        searchParamMap["REQ_PRIORITY"]= vm.model.requestPriorities;
      searchParamMap["PC_CONTRACT_TYPE"]= vm.model.searchCriteria.flexiContract == null ? "" : vm.model.searchCriteria.flexiContract.contractCode;
      console.log(searchParamMap);
        return searchParamMap;
    }

    vm.changeViewMode = function () {
        vm.model.isFullScreen = !vm.model.isFullScreen
    };

    vm.onClick = function (eventType, data, view) {
        EventManagerService.notifyEventListeners(eventType, data, view);
    };


    vm.changeFleet = function (){
    	var list = TargetHoursService.getMappedData(vm.model.searchCriteria.modelNumber);
    	vm.targetHoursDataList = TargetHoursService.getFormattedData(list);
    	vm.model.gridDataList = [];
      	 for(var i=0, index=0; i < (vm.targetHoursDataList.length < vm.limitIndex ? vm.targetHoursDataList.length : vm.limitIndex); i++){
      		 $timeout(function(){
      			 vm.model.gridDataList.push(vm.targetHoursDataList[index]);
      			 index++;
      		 });
      	  }
    };

    CommonMasterData.getCrewTypeList(function(crewTypes){
        vm.model.masterList.crewTypes = crewTypes;
    },function () {});

    CommonMasterData.getAircraftModelList(function(acModels){
      vm.model.masterList.acModels = acModels;
    },function () {});

    AutoRosterScheduleService.getRosterCycles(function (response) {
        vm.model.masterList.cycleList = response;
    },function (error) {});

    CommonMasterData.getCrewBaseList(function(crewBases){
        vm.model.masterList.crewBases = crewBases;
    },function () {});

    CommonMasterData.getOffContracts(function(response){
        vm.model.masterList.flexiContractList = response.offContracts;
    }, function () {});

    CommonMasterData.getCrewGroups(function(crewGroups){
        vm.model.masterList.crewGroups = crewGroups.crewGroups;
    },function () {});
  }
}());
